// removed by extract-text-webpack-plugin
module.exports = {"demo-display":"_1qF-6","demoDisplay":"_1qF-6","disabled":"_2XU7H"};